module.exports = __webpack_public_path__ + "img/altitude.522e853b.svg";